// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.abastecimento.title': 'Solicitação de abastecimento',
    'shipments.abastecimento.descricao': 'O operador preenche máquina, CPF, cooperante e fazenda. Digite a hora da máquina; litros já vem com 400. O motorista preenche a placa do utilitário. Salvar gera a imagem, copia e registra a solicitação com o responsável, a data e a hora.',
    'shipments.abastecimento.maquina': 'Máquina',
    'shipments.abastecimento.data': 'Data',
    'shipments.abastecimento.horaMaquina': 'Hora máquina',
    'shipments.abastecimento.litros': 'Litros',
    'shipments.abastecimento.cooperante': 'Cooperante',
    'shipments.abastecimento.fazenda': 'Fazenda',
    'shipments.abastecimento.motorista': 'Motorista do caminhão',
    'shipments.abastecimento.semMotorista': 'Sem motorista',
    'shipments.abastecimento.placaUtilitario': 'Placa do cavalo',
    'shipments.abastecimento.previewAlt': 'Prévia da imagem da solicitação',
    'shipments.abastecimento.salvar': 'Salvar e copiar imagem',
    'shipments.abastecimento.salva': 'Solicitação registrada. Baixe ou copie a imagem.',
    'shipments.abastecimento.salvaECopiada': 'Solicitação registrada e imagem copiada. Cole no grupo do WhatsApp.',
    'shipments.abastecimento.solicitar': 'Solicitar abastecimento',
  },
  en: {
    'shipments.abastecimento.title': 'Fuel request',
    'shipments.abastecimento.descricao': 'The operator fills in machine, CPF, cooperant and farm. Type the machine hours; litres start at 400. The driver fills in the utility vehicle plate. Saving builds the image, copies it and records the request with the person in charge, date and time.',
    'shipments.abastecimento.maquina': 'Machine',
    'shipments.abastecimento.data': 'Date',
    'shipments.abastecimento.horaMaquina': 'Machine hours',
    'shipments.abastecimento.litros': 'Litres',
    'shipments.abastecimento.cooperante': 'Cooperant',
    'shipments.abastecimento.fazenda': 'Farm',
    'shipments.abastecimento.motorista': 'Truck driver',
    'shipments.abastecimento.semMotorista': 'No driver',
    'shipments.abastecimento.placaUtilitario': 'Tractor unit plate',
    'shipments.abastecimento.previewAlt': 'Request image preview',
    'shipments.abastecimento.salvar': 'Save and copy image',
    'shipments.abastecimento.salva': 'Request recorded. Download or copy the image.',
    'shipments.abastecimento.salvaECopiada': 'Request recorded and image copied. Paste it in the WhatsApp group.',
    'shipments.abastecimento.solicitar': 'Request fuel',
  },
  es: {
    'shipments.abastecimento.title': 'Solicitud de abastecimiento',
    'shipments.abastecimento.descricao': 'El operador rellena máquina, CPF, cooperante y hacienda. Escribe la hora de la máquina; litros ya viene con 400. El conductor rellena la placa del utilitario. Guardar genera la imagen, la copia y registra la solicitud con el responsable, la fecha y la hora.',
    'shipments.abastecimento.maquina': 'Máquina',
    'shipments.abastecimento.data': 'Fecha',
    'shipments.abastecimento.horaMaquina': 'Hora máquina',
    'shipments.abastecimento.litros': 'Litros',
    'shipments.abastecimento.cooperante': 'Cooperante',
    'shipments.abastecimento.fazenda': 'Hacienda',
    'shipments.abastecimento.motorista': 'Conductor del camión',
    'shipments.abastecimento.semMotorista': 'Sin conductor',
    'shipments.abastecimento.placaUtilitario': 'Placa del tractocamión',
    'shipments.abastecimento.previewAlt': 'Vista previa de la imagen de la solicitud',
    'shipments.abastecimento.salvar': 'Guardar y copiar imagen',
    'shipments.abastecimento.salva': 'Solicitud registrada. Descarga o copia la imagen.',
    'shipments.abastecimento.salvaECopiada': 'Solicitud registrada e imagen copiada. Pégala en el grupo de WhatsApp.',
    'shipments.abastecimento.solicitar': 'Solicitar abastecimiento',
  },
}
